export default __webpack_public_path__ + "static/media/icon-qrcode.e475d40a.svg";